module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAb1BMVEUAAAABAAICAAQBAAICAAMDAAMBAAIBAAICAAMCAAIDAAMEAAQFAAUDAAMFAAUCAAMCAAIDAAMkACQCAAQBAAIBAAIBAAIBAAIBAAMBAAMBAAMBAAMBAAMCAAQCAAIDAAMEAAQHAAcMAAwVABUDAAMuGM1GAAAAJXRSTlMA9YHyoE3Z1JF0WDotRjOnbWEHhe3p5ODHu7i3r4loUDkkFQxdmn+zLgAAALdJREFUGNNdj+kSgjAQg7MtPUAOAZX7EHz/Z5TSFsH82Ga+nWS6sLoNjVIti433qObZKKZ7T92BQ2KrdYumyLHnbB6Wmyn4ThNK913AsFMyDSrEGUJ32+ZVXOFCMQKNK0TPIMU/vLfgqYelM5MC+e9++M0aoSAT+JijY4OsxEFtVTYgkjiUm9S6BYoqx0Ws3kb0eJ/ZTHuzlieaPt3V+uEbipAsMw2VLJM4Ffqlkl+oiDJJXAbu5C8tdgdbuiZ5QgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/entrega.png
// module id = 487
// module chunks = 0